"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.META = exports.LOADING = exports.createLoading = undefined;

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _extends4 = require("babel-runtime/helpers/extends");

var _extends5 = _interopRequireDefault(_extends4);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _fluxStandardAction = require("flux-standard-action");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW = "@SAGAMODEL_LOADING/SHOW";
var HIDE = "@SAGAMODEL_LOADING/HIDE";
var NAMESPACE = "loading";
var LOADING = "LOADING";

var META = (0, _defineProperty3.default)({}, LOADING, true);

function createLoading() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var namespace = opts.namespace || NAMESPACE;
  var initialState = {
    global: false,
    models: {}
  };

  return {
    onSaga: function onSaga(prevSaga, _ref, model, actionType) {
      var put = _ref.put;

      return (/*#__PURE__*/_regenerator2.default.mark(function _callee(action) {
          var _action$meta, meta, _namespace, saga;

          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(0, _fluxStandardAction.isFSA)(action)) {
                    _context.next = 17;
                    break;
                  }

                  _action$meta = action.meta, meta = _action$meta === undefined ? {} : _action$meta;
                  _namespace = model.namespace;

                  if (!meta[LOADING]) {
                    _context.next = 13;
                    break;
                  }

                  saga = actionType.substr(actionType.lastIndexOf("/") + 1);
                  _context.next = 7;
                  return put({
                    type: SHOW,
                    payload: {
                      namespace: _namespace,
                      saga: saga
                    }
                  });

                case 7:
                  _context.next = 9;
                  return prevSaga(action);

                case 9:
                  _context.next = 11;
                  return put({
                    type: HIDE,
                    payload: {
                      namespace: _namespace,
                      saga: saga
                    }
                  });

                case 11:
                  _context.next = 15;
                  break;

                case 13:
                  _context.next = 15;
                  return prevSaga(action);

                case 15:
                  _context.next = 19;
                  break;

                case 17:
                  _context.next = 19;
                  return prevSaga(action);

                case 19:
                  return _context.abrupt("return");

                case 20:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        })
      );
    },

    extraReducers: (0, _defineProperty3.default)({}, NAMESPACE, function (state, action) {
      var _extends2, _extends3;

      var sagaNamespace = void 0,
          namespaceWithSagaRegExp = void 0;

      var type = action.type,
          payload = action.payload;


      switch (type) {
        case SHOW:
          sagaNamespace = payload.namespace + "/" + payload.saga;
          namespaceWithSagaRegExp = RegExp(payload.namespace + "/\\w+$");

          initialState = {
            global: true,
            models: (0, _extends5.default)({}, state.models, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, payload.namespace, true), (0, _defineProperty3.default)(_extends2, sagaNamespace, true), _extends2))
          };
          break;

        case HIDE:
          sagaNamespace = payload.namespace + "/" + payload.saga;
          namespaceWithSagaRegExp = RegExp(payload.namespace + "/\\w+$");
          // 计算当前带 saga 名称的 namespace 的个数
          var namespaceShowNum = (0, _keys2.default)(state.models).reduce(function (num, key) {
            return namespaceWithSagaRegExp.test(key) && state.models[key] && ++num, num;
          }, 0);

          // 如果比一个多就证明还存在其他的 saga 在 loading
          var namespaceStatu = namespaceShowNum > 1 ? true : false;

          var models = (0, _extends5.default)({}, state.models, (_extends3 = {}, (0, _defineProperty3.default)(_extends3, payload.namespace, namespaceStatu), (0, _defineProperty3.default)(_extends3, sagaNamespace, false), _extends3));
          var global = (0, _keys2.default)(models).some(function (namespace) {
            return models[namespace];
          });

          initialState = {
            global: global,
            models: models
          };
          break;

        default:
          break;
      }
      return initialState;
    })
  };
}

exports.createLoading = createLoading;
exports.LOADING = LOADING;
exports.META = META;
exports.default = createLoading();


//////////////////
// WEBPACK FOOTER
// ./~/redux-saga-model-loading/lib/plugin.js
// module id = 197
// module chunks = 0